import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import { State } from '../../../../../../reducers'
import { actionFaturacionSucursal } from '../../../../../../actions/action-creators'
import { isNullOrEmpty } from '../../../../../../utils/strings.utils'
import { useEffect } from 'react'
import { encontrarSerieActiva, encontrarSucursalConDocs } from '../../../../../../utils/invoice/sucursales_docs'
import { facturacionSetCatalogoSerie } from '../../../../../../actions/facturacion/facturacionEmision.actions'
import { facturacionFormSucursalHandleChange } from '../../../../../../actions/facturacion/facturacionSucursal.actions'
import SearchSelect from '../../../../../../components/Inputs/SearchSelect'

const DatosSucursalV1 = (props: any) => {
  const {docActual} = props;
  const sucursales = useSelector((state: State) => state.facturacion.catalogoSucursal)
  const series = useSelector((state: State) => state.facturacion.catalogoSerie)
  const form = useSelector((state: State) => state.facturacion.formSucursal)
  const errors = useSelector((state: State) => state.facturacion.errorsFormSucursal)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionFaturacionSucursal, dispatch)

  useEffect(() => {
    if (sucursales.length > 0) {
      try {
        // Encontrar sucursal activa con documentos
        const sucursalConDocs = encontrarSucursalConDocs(sucursales, docActual);
        // Encontrar la serie
        const serieDefault = encontrarSerieActiva(sucursalConDocs.Documento, docActual);
        // Setear datos por defecto
        dispatch(facturacionSetCatalogoSerie(sucursalConDocs.Documento));
        dispatch(facturacionFormSucursalHandleChange({
          'sucursal': sucursalConDocs.idsucursal, 
          'serie': serieDefault.idsucursaldocumento, 
          'datosSerie': serieDefault,
        }));
      } catch(e) {}
    }
  }, [sucursales]);

  return (
    <form
      className='form-content'
      data-wf-page-id='64b58c72be2b65200b1e6fa6'
      data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
      
      style={{marginBottom: '5%'}}
    >
      <div>
        <h3 className='card-title l'>Sucursal y Serie</h3>
      </div>
      <div className='form-separator'></div>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='sucursal' className='field-label m'>
            Sucursal
            <span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect 
            placeholder='Sucursal' 
            data={sucursales.filter(suc => suc.activo === "true" && suc.Asignado === true)} 
            keyNameText='nombre' 
            keyNameValue='idsucursal' 
            value={form.sucursal} 
            name='sucursal' 
            disabled = {false} 
            onChange={(value: any) => {acciones.facturacionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'sucursal'}}) ;acciones.facturacionFormSucursalOnBlur({target: {value: value?.value, name: 'sucursal'}}) }}
          />
          {errors.sucursal && <p className='alert s'>{errors.sucursal}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='serie' className='field-label m'>
            Serie
            <span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect 
            placeholder='Serie' 
            data={series.filter(serie => serie.estado === "true" && serie.iddocumento === docActual).map((serie) => {return({...serie, serie_numero: `${serie?.serie}-${serie?.numeroactual}`})})} 
            keyNameText='serie_numero' 
            keyNameValue='idsucursaldocumento' 
            value={form.serie} 
            name='serie' 
            disabled = {false} 
            onChange={(value: any) => {acciones.facturacionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'serie'}}) ;acciones.facturacionFormSucursalOnBlur({target: {value: value?.value, name: 'serie'}}) }}
          />
          {errors.serie && <p className='alert s'>{errors.serie}</p>}
        </div>
      </div>
      <div className='separador'></div>
    </form>
  )
}

export default DatosSucursalV1
